import pushClevertapEvent from 'clevertap/pushClevertapEvent';

export function accountSettingsOpenBankAccount() {
  pushClevertapEvent('Setting Bank Account');
}

export function accountSettingsViewBankAccount() {
  pushClevertapEvent('Setting View Bank');
}

export function accountSettingsAddBankAccount() {
  pushClevertapEvent('Setting Add Bank');
}

export function accountSettingsSaveNewBankAccount(bank, outletData, profile) {
  const bankData = generateClevertapBankAccountData(bank, outletData, profile);
  pushClevertapEvent('Setting New Bank', bankData);
}

export function accountSettingsEditSaveBankAccount(bank, outletData, profile) {
  const bankData = generateClevertapBankAccountData(bank, outletData, profile);
  pushClevertapEvent('Setting Edit Bank', bankData);
}

function generateClevertapBankAccountData(bank, outletData, profile) {
  const bankData = {
    'Bank Name': bank.bankName,
    'Bank Account Number': bank.accountNumber,
    'Bank Account Name': bank.accountHolderName,
    'Assigned Outlets': outletData.join(','),
    'Total # of Outlets Assigned': outletData.length,
    'Backoffice email': profile.data.email,
    'Business ID': profile.data.business.id,
  };
  return bankData;
}

// bank account v2
export function accountSettingsBankAccountAdd(
  bankAccount,
  newOutletIds,
  profile
) {
  const bankAccountData = generateClevertapBankAccountData(
    bankAccount,
    newOutletIds,
    profile
  );
  pushClevertapEvent('Setting Add Bank', bankAccountData);
}

export function accountSettingsBankAccountUpdate(
  bankAccount,
  newOutletIds,
  profile
) {
  const bankAccountData = generateClevertapBankAccountData(
    bankAccount,
    newOutletIds,
    profile
  );
  pushClevertapEvent('Setting Update Bank', bankAccountData);
}

export function accountSettingsBankAccountDelete(bankAccount, profile) {
  pushClevertapEvent('Setting Delete Bank', {
    'Bank Name': bankAccount.bankName,
    'Bank Account Number': bankAccount.accountNumber,
    'Bank Account Name': bankAccount.accountHolderName,
    'Backoffice email': profile.email,
    'Business ID': profile.business.id,
  });
}

export function accountSettingsBankAccountActivityLog() {
  pushClevertapEvent('Setting Activity Log');
}

export function accountSettingsBankAccountActivityLogDetails() {
  pushClevertapEvent('Setting Activity Log Details');
}
